const PbxxRecord = require('../pbxx_record')

const facebook_ad_types = {
  audience_network: 'MOBILE',
  desktop_mobile: 'FACEBOOK',
  instagram: 'INSTAGRAM'
}

module.exports = class AdRunTask extends PbxxRecord {
  static get class_name() {
    return 'AdRunTask'
  }

  get channel_name() {
  	let channel_name = this.channel.toUpperCase()

  	if (this.facebook_ad_type) {
  	  channel_name = facebook_ad_types[this.channel_display] || 'FACEBOOK'
  	}

  	return channel_name
  }

  get task_status() {
  	let status = this.status.toUpperCase()

  	if (this.status === 'canceled' && (this.intended_self_fund_amount_cents || this.intended_retailer_wallet_amount_cents)) {
  	  status = 'REFUNDED'
  	} else if (this.status === 'failure') {
  	  status = 'PENDING'
  	}

    return status
  }

  get ad_run_task_duration() {
    let start_time = this.channel_object && this.channel_object.fb_start_time ? moment(this.channel_object.fb_start_time).format('MMM D, YYYY') : ''
    let end_time = this.channel_object && this.channel_object.fb_end_time ? moment(this.channel_object.fb_end_time).format('MMM D, YYYY') : ''

    return start_time + ' - ' + end_time
  }

}
